import React from 'react';
import { motion } from 'framer-motion';
import { FaCheck, FaExclamation } from 'react-icons/fa';

// La ruta de puesta en marcha: cinco paradas en orden. El tramo recorrido se pinta en cian (funciona) y la siguiente parada
// en rojo (lo que falta). Cada parada lleva a donde se resuelve.
export default function ReadinessTrack({ steps, onSelect, compact = false }) {
  const done = steps.filter((s) => s.state === 'done').length;
  const lastDoneIndex = steps.reduce((acc, s, i) => (s.state === 'done' ? i : acc), -1);
  const progress = steps.length > 1 ? Math.max(0, lastDoneIndex) / (steps.length - 1) : 0;

  if (compact) {
    const next = steps.find((s) => s.state !== 'done');
    return (
      <div aria-label={`Puesta en marcha: ${done} de ${steps.length}${next ? `; falta ${next.label}` : ''}`}>
        <div className="flex items-center gap-1" aria-hidden>
          {steps.map((s) => (
            <span key={s.key} className={`h-1.5 flex-1 min-w-[12px] rounded-full ${s.state === 'done' ? 'bg-live' : s.state === 'problem' ? 'bg-caution' : s.state === 'next' ? 'bg-signal' : 'bg-line'}`} />
          ))}
        </div>
        <p className="mt-1.5 text-[12px] text-fg-dim" aria-hidden>
          <span className="tabular-nums">{done} de {steps.length}</span>
          {next ? <span className="text-fg-faint"> · falta {next.label.toLowerCase()}</span> : <span className="text-live"> · listo</span>}
        </p>
      </div>
    );
  }

  return (
    <nav aria-label="Puesta en marcha del agente" className="relative">
      {/* línea base y tramo recorrido (solo en pantallas anchas) */}
      <div className="hidden md:block absolute left-[10%] right-[10%] top-[15px] h-px bg-line" aria-hidden>
        <motion.div className="h-full bg-live origin-left" initial={false} animate={{ scaleX: progress }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} />
      </div>
      <ol className="relative grid grid-cols-1 md:grid-cols-5 gap-2 md:gap-0">
        {steps.map((s, i) => {
          const tone = s.state === 'done' ? 'border-live bg-live text-ink'
            : s.state === 'next' ? 'border-signal bg-ink text-signal ring-4 ring-signal/15'
            : s.state === 'problem' ? 'border-caution bg-ink text-caution'
            : 'border-fg/15 bg-ink text-fg-faint';
          const stateText = s.state === 'done' ? 'listo' : s.state === 'next' ? 'siguiente paso' : s.state === 'problem' ? 'requiere atención' : 'pendiente';
          return (
            <li key={s.key} className="md:text-center">
              <button
                type="button"
                onClick={() => onSelect?.(s.key)}
                aria-current={s.state === 'next' ? 'step' : undefined}
                className="group w-full flex md:flex-col items-center md:items-center gap-3 md:gap-2 rounded-lg p-2 md:p-1.5 text-left md:text-center
                  hover:bg-raised/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live/60"
              >
                <span className={`grid place-items-center h-[30px] w-[30px] shrink-0 rounded-full border-2 text-[12px] font-semibold tabular-nums ${tone}`}>
                  {s.state === 'done' ? <FaCheck aria-hidden className="h-3 w-3" /> : s.state === 'problem' ? <FaExclamation aria-hidden className="h-3 w-3" /> : i + 1}
                </span>
                <span className="min-w-0">
                  <span className={`block text-[13px] font-medium ${s.state === 'pending' ? 'text-fg-dim' : 'text-fg'}`}>{s.label}</span>
                  <span className="block text-[12px] text-fg-faint truncate">{s.detail}</span>
                  <span className="sr-only">: {stateText}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
